'use strict';

var cache = {};

module.exports = {
    initTabCache: function () {
        cache.$document = $(document);
        cache.$window = $(window);
    },
    getSlider: function () {
        cache.$document.on('tab:changed', function (e, dataEvent) {
            var $selectedTab = dataEvent.$selectedTab;
            var tabRequested = $selectedTab.attr('data-requested') == 'true';
            var $sliderLoaded = $selectedTab.find('.js-tabs-recommendation-slider');

            cache.$window.trigger('alignTiles', {container: $sliderLoaded, resetHeight: true});

            if ($sliderLoaded && $sliderLoaded.length > 0 && $sliderLoaded.hasClass('slick-initialized')) {
                $sliderLoaded[0].slick.refresh();
            }

            if (tabRequested) {
                return;
            }

            var url = $selectedTab.data('recs-endpoint');
            var $container = $selectedTab.closest('.js-category-tabs');
            var data = {
                cgid: $selectedTab.data('category-id'),
                bbwCarouselTilesMobile: $selectedTab.data('tiles-mobile') || '',
                bbwCarouselTilesTablet: $selectedTab.data('tiles-tablet') || '',
                bbwCarouselTilesDesktop: $selectedTab.data('tiles-desktop') || '',
                showHalfTile: $selectedTab.data('tiles-half') || '',
                listName: $selectedTab.data('list-name'),
            };

            $container.spinner().start();

            $.ajax({
                url: url,
                data: data
            }).done(function (response) {
                $selectedTab.attr('data-requested', 'true');
                $selectedTab.html(response);

                var $slider = $selectedTab.find('.js-tabs-recommendation-slider');

                cache.$document.trigger('init:initTabsRecsSlider', {$slider: $slider});
            }).always(function () {
                $container.spinner().stop();
            });
        });
    }
};
